import LaravelEcho from 'laravel-echo'
import Pusher from 'pusher-js'
import PusherBatchAuthorizer from '@/util/PusherBatchAuthorizer'
import axios from './axios'


export default class Echo extends LaravelEcho {
    constructor() {
        super({
            // echo no longer bundles the client; hand it the Pusher class.
            // pusher-js 8 keeps honoring the legacy `authorizer` option by
            // proxying it into channelAuthorization.customHandler.
            Pusher,
            // we register our own axios interceptor below
            withoutInterceptors: true,
            key: import.meta.env.VUE_APP_PUSHER_APP_KEY,
            // pusher-js 8 requires the key to exist even though it's unused
            // when wsHost points at a self-hosted websocket server
            cluster: '',
            wsHost: import.meta.env.VUE_APP_PUSHER_APP_WS_HOST,
            wsPort: import.meta.env.VUE_APP_PUSHER_APP_WS_PORT || 6001,
            wssPort: import.meta.env.VUE_APP_PUSHER_APP_WSS_PORT || 6001,
            enableStats: false,
            authEndpoint: `${import.meta.env.VUE_APP_PUSHER_APP_URL}/v1/broadcasting/batch-auth`,
            authorizer: PusherBatchAuthorizer,
            authDelay: 200,
            host: new URL(import.meta.env.VUE_APP_PUSHER_APP_URL).hostname,
            enabledTransports: ['ws', 'wss'],
            forceTLS: true,
            broadcaster: 'pusher',
        })
        this.registerAxiosRequestInterceptor()
        setTimeout(() => {
            try {
                this.connector.pusher.connection.strategy.transports.wss.transport.manager.livesLeft = Infinity
                this.connector.pusher.connection.strategy.transports.ws.transport.manager.livesLeft = Infinity
            } catch (e) {
                console.warn(e)
            }
        }, 2000)
    }

    /**
     * Register an Axios HTTP interceptor to add the X-Socket-ID header.
     */
    registerAxiosRequestInterceptor() {
        axios.interceptors.request.use((config) => {
            if (this.socketId()) {
                config.headers['X-Socket-Id'] = this.socketId()
            }

            return config
        })
    }
}
